module.exports = {
  title: 'Magic Button with React Native Skia 🪄',
  author: 'Enzo Manuel Mangano',
  date: '2024-05-08',
  slug: 'geometry-button',
  tags: ['skia'],
};
